import {
  Component,
  OnInit,
  AfterViewInit,
  Inject,
  Output,
  EventEmitter,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { DbService } from '../core/services/db.service';
import { AuthService } from '../core/services/auth.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  configData;
  openSwitch = false;

  inquiry$: Observable<any>;

  menu = [
    {
      label: '대시보드',
      icon: 'bx-home',
      link: '/dashboard',
      alarmSwitch: false,
    },
    {
      label: '회원 관리',
      icon: 'bx-user',
      link: '/user-list',
      alarmSwitch: false,
    },
    {
      label: '딜 관리',
      icon: 'bx-list-ul',
      alarmSwitch: false,
      subItems: [
        {
          label: '딜',
          link: '/deal-list',
          alarmSwitch: false,
        },
      ],
    },
    {
      label: '후기 관리',
      icon: 'bx-error',
      alarmSwitch: false,
      subItems: [
        {
          label: '후기',
          link: '/review-list',
          alarmSwitch: false,
        },
      ],
    },
    {
      label: '결제 관리',
      icon: 'bx-credit-card',
      alarmSwitch: false,
      subItems: [
        {
          label: '결제 관리',
          link: '/payment-list',
          alarmSwitch: false,
        },
        {
          label: '인출 요청',
          link: '/exchange-list',
          alarmSwitch: false,
        },
        {
          label: '환불 요청',
          link: '/refund-request',
          alarmSwitch: false,
        },
      ],
    },
    {
      label: '신고 관리',
      icon: 'bx-credit-card',
      alarmSwitch: false,
      subItems: [
        {
          label: '채팅 및 유저 신고 관리',
          link: '/chat-report',
          alarmSwitch: false,
        },
        {
          label: '후기 신고 관리',
          link: '/review-report',
          alarmSwitch: false,
        },
      ],
    },
    {
      label: '서비스/정보관리',
      icon: 'bx-note',
      alarmSwitch: false,
      subItems: [
        {
          label: '이벤트',
          link: '/event-list',
          alarmSwitch: false,
        },
        {
          label: '공지사항',
          link: '/notice',
          alarmSwitch: false,
        },
        {
          label: 'FAQ',
          link: '/faq',
          alarmSwitch: false,
        },
        {
          label: '1:1 문의',
          link: '/inquiry',
          alarmSwitch: false,
        },

        {
          label: '개인정보/서비스 이용약관',
          link: '/terms',
          alarmSwitch: false,
        },
      ],
    },
  ];

  routerUrl: string;

  constructor(
    // private eventService: EventService,
    private router: Router,
    @Inject(DOCUMENT) private document: any,
    private db: DbService,
    private auth: AuthService
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        // this._activateMenuDropdown();
        this.routerUrl = event.url;
      }
    });
  }

  ngOnInit() {
    //사이드바 정의
    document.body.setAttribute('data-sidebar', 'dark');
    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };
    this.getData();
  }

  getData() {
    // 1:1 문의
    this.db
      .collection$('inquiry', (ref) => ref.where('readSwitch', '==', false))
      .subscribe((val) => {
        this.menu[6].alarmSwitch = this.menu[6].subItems[3].alarmSwitch =
          val?.length > 0;
      });

    // 신고
    this.db
      .collection$('report', (ref) => ref.where('readSwitch', '==', false))
      .subscribe((val) => {
        const chatReport = val.filter((v) => v.type === 'chat');
        this.menu[5].subItems[0].alarmSwitch = chatReport?.length > 0;
        const reviewReport = val.filter((v) => v.type === 'review');
        this.menu[5].subItems[1].alarmSwitch = reviewReport?.length > 0;
        this.menu[5].alarmSwitch =
          chatReport?.length > 0 || reviewReport?.length > 0;
      });

    // 결제관리
    let point;
    this.db
      .collection$('point', (ref) =>
        ref.where('readSwitch', '==', false).where('type', '==', '포인트구매')
      )
      .subscribe((val) => {
        point = val;
        this.menu[4].subItems[0].alarmSwitch = val?.length > 0;
        this.menu[4].alarmSwitch =
          this.menu[4].subItems[2].alarmSwitch ||
          this.menu[4].subItems[0].alarmSwitch ||
          this.menu[4].subItems[1].alarmSwitch;
      });

    // 인출요청
    let withdrawal;
    this.db
      .collection$('withdrawal', (ref) => ref.where('readSwitch', '==', false))
      .subscribe((val) => {
        withdrawal = val;
        this.menu[4].subItems[1].alarmSwitch = val?.length > 0;
        this.menu[4].alarmSwitch =
          this.menu[4].subItems[2].alarmSwitch ||
          this.menu[4].subItems[1].alarmSwitch ||
          this.menu[4].subItems[0].alarmSwitch;
      });

    // 환불요청
    let refund;
    this.db
      .collection$('refund', (ref) => ref.where('readSwitch', '==', false))
      .subscribe((val) => {
        refund = val;
        this.menu[4].subItems[2].alarmSwitch = val?.length > 0;
        this.menu[4].alarmSwitch =
          this.menu[4].subItems[2].alarmSwitch ||
          this.menu[4].subItems[1].alarmSwitch ||
          this.menu[4].subItems[0].alarmSwitch;
      });
  }

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  isCondensed = false;

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    this.onSettingsButtonClicked();
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');

    if (window.screen.width <= 768) {
      document.body.classList.remove('vertical-collpsed');
    }
  }

  ngAfterViewInit() {
    // this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  scrollable() {
    document.body.setAttribute('data-layout-scrollable', 'true');
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    // this.mobileMenuButtonClicked.emit();
    this.onToggleMobileMenu();
  }

  /**
   * Logout the user
   */
  logout() {
    this.auth.logoutUser().then(() => {
      this.router.navigate(['/account/login']);
    });
  }

  public hide() {
    document.body.classList.remove('right-bar-enabled');
  }

  open(list, menu, mi) {
    const activeTag = document.querySelector<HTMLElement>('.active');
    if (activeTag) {
      activeTag.classList.remove('active');
    }
    if (list.openSwitch) {
      list.openSwitch = false;
    } else {
      list.openSwitch = true;
      menu.forEach((ele) => {
        if (ele != list && ele.openSwitch == true) {
          ele.openSwitch = false;
        }
      });

      if (list.subItems && list.subItems.length > 0) {
        for (let index = 0; index < list.subItems.length; index++) {
          const element = list.subItems[index];

          if (element.link == this.routerUrl) {
            const aTag = document.querySelector<HTMLElement>(
              `.atag${mi}${index}`
            );
            aTag.classList.add('active');
          }
        }
      }
    }
  }

  close(aTag: HTMLElement) {
    aTag.classList.add('active');
    this.menu.forEach((ele: any) => {
      ele.openSwitch = false;
    });
  }

  //클릭시 active class
  // _activateMenuDropdown() {
  //   this._removeAllClass('mm-active');
  //   this._removeAllClass('mm-show');
  //   const links = document.getElementsByClassName('side-nav-link-ref');
  //   let menuItemEl = null;
  //   // tslint:disable-next-line: prefer-for-of
  //   const paths = [];
  //   for (let i = 0; i < links.length; i++) {
  //     paths.push(links[i]['pathname']);
  //   }
  //   var itemIndex = paths.indexOf(window.location.pathname);
  //   if (itemIndex === -1) {
  //     const strIndex = window.location.pathname.lastIndexOf('/');
  //     const item = window.location.pathname.substr(0, strIndex).toString();
  //     menuItemEl = links[paths.indexOf(item)];
  //   } else {
  //     menuItemEl = links[itemIndex];
  //   }
  //   if (menuItemEl) {
  //     menuItemEl.classList.add('active');
  //     const parentEl = menuItemEl.parentElement;
  //     if (parentEl) {
  //       parentEl.classList.add('mm-active');
  //       const parent2El = parentEl.parentElement.closest('ul');
  //       if (parent2El && parent2El.id !== 'side-menu') {
  //         parent2El.classList.add('mm-show');
  //         const parent3El = parent2El.parentElement;
  //         if (parent3El && parent3El.id !== 'side-menu') {
  //           parent3El.classList.add('mm-active');
  //           const childAnchor = parent3El.querySelector('.has-arrow');
  //           const childDropdown = parent3El.querySelector('.has-dropdown');
  //           if (childAnchor) {
  //             childAnchor.classList.add('mm-active');
  //           }
  //           if (childDropdown) {
  //             childDropdown.classList.add('mm-active');
  //           }
  //           const parent4El = parent3El.parentElement;
  //           if (parent4El && parent4El.id !== 'side-menu') {
  //             parent4El.classList.add('mm-show');
  //             const parent5El = parent4El.parentElement;
  //             if (parent5El && parent5El.id !== 'side-menu') {
  //               parent5El.classList.add('mm-active');
  //               const childanchor = parent5El.querySelector('.is-parent');
  //               if (childanchor && parent5El.id !== 'side-menu') {
  //                 childanchor.classList.add('mm-active');
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // }

  // // 메뉴 클릭시 다른주소 remove class
  // _removeAllClass(className) {
  //   const els = document.getElementsByClassName(className);
  //   while (els[0]) {
  //     els[0].classList.remove(className);
  //   }
  // }
}
